import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const button = css`
  align-self: start;
  padding-left: 0 !important;
  margin-bottom: var(--space-300);
  font-weight: 500;
  text-align: left;
  color: var(--brand-dark);
  background-color: transparent;
  border: 0;

  &:hover {
    color: var(--control-hover-accent) !important;
    background-color: transparent;
    --translate-distance: 0;
  }
`;

export const buttons = css`
  display: flex;
  justify-content: space-between;
  margin: var(--space-100) 0 var(--space-300);

  ${breakpoints.only.mobile} {
    width: 100vw;
    margin-left: -16px;
    overflow-x: scroll;
    & > div:first-child {
      margin-left: var(--space-200);
    }
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  & > div {
    margin-right: var(--space-100);
  }
`;

export const buttonDay = css`
  width: 50px;

  ${breakpoints.only.mobile} {
    min-width: 66px;
    width: 66px;
  }
`;

export const holiday = css`
  display: flex;
  flex-direction: column;
  padding: var(--space-200);
  margin: var(--space-400) 0 var(--space-100);
  background: var(--secondary-yellow-light);
  border-radius: var(--space-100);
`;

export const holidayCaption = css`
  margin-bottom: var(--space-50);
`;
